import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { css } from '@emotion/core'
import { string } from 'prop-types'
import { useContainerWidth, Avatar } from '@fs/zion-ui'
import { determineGender } from '../shared/helpers/gedcom_X'

export default function AncestorAvatar({ fieldName, fieldValue, genderType }) {
  const [t] = useTranslation()
  const atWidth = useContainerWidth()
  const [imageError, setImageError] = useState(false)

  const ancestorPlaceholderContainer = css`
    justify-content: center;
    align-content: top;
    padding: 0 2em;
    position: absolute;
    top: -60px;
    display: flex;
    align-items: flex-start;
    inset-inline-start: 0;
    inset-inline-end: 0;
  `

  const portraitCss = css`
    border-radius: 50%;
    box-shadow: inset 0 2px 4px 0 hsla(0, 0%, 51.8%, 0.5);
    margin: 0 auto;
  `

  return (
    <div css={ancestorPlaceholderContainer}>
      {fieldValue && !imageError ? (
        <img
          name={fieldName}
          src={fieldValue}
          alt={t('atf.ancestor-editor.ancestor-portrait', "Your ancestor's photo.")}
          onError={() => setImageError(true)}
          width="88"
          height="88"
          css={portraitCss}
        />
      ) : (
        <Avatar size={atWidth({ default: 'lg' })} sex={determineGender(genderType)} />
      )}
    </div>
  )
}

AncestorAvatar.propTypes = {
  fieldName: string,
  fieldValue: string,
  genderType: string,
}
